<template>
  <div class="picklrs-page">
    <div class="filter-panels">
      <div class="filter-panel">
        <div class="filter-panel-header" @click="togglePersonalFilters">
          <span class="filter-panel-title">Address & Personal Filters</span>
          <span class="filter-toggle" v-html="showPersonalDetailsFilter ? '−' : '+'"></span>
        </div>
        <div class="filter-panel-body" v-show="showPersonalDetailsFilter">
          <input class="btn-select" type="text" placeholder="Name" v-model="name" />
          <input class="btn-select" type="text" placeholder="Email" v-model="email" />
          <select v-model="isEmailValid">
            <option value="">Valid Emails?</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
          <select v-model="countryId" @change="getStatesByCountry">
            <option value="">Select Country</option>
            <option v-for="country in countries" :key="country.id" :value="country.id">{{country.name}}</option>
          </select>
          <select v-model="stateName">
            <option value="">Select State</option>
            <option v-for="state in states" :key="state.id" :value="state.name">{{state.name}}</option>
          </select>
          <input class="btn-select" type="text" placeholder="City" v-model="city" />
          <input class="btn-select" type="text" placeholder="Mobile Number" v-model="mobileNumber" />
          <select v-model="status">
            <option value>All</option>
            <option value="ACTIVE">Active</option>
            <option value="INACTIVE">Inactive</option>
            <option value="BLOCKED">Blocked</option>
            <option value="REPORTED">Reported</option>
          </select>
          <input class="btn-select" type="text" placeholder="Zipcode" v-model="zipCode" />
          <select v-model="sort">
            <option value="created_at-DESC" selected>Sign-up &#8595;</option>
            <option value="created_at-ASC">Sign-up &#8593;</option>
            <option value="name-ASC">A-Z</option>
            <option value="name-DESC">Z-A</option>
            <option value="current_credits-ASC">Due &#8593;</option>
            <option value="current_credits-DESC">Due &#8595;</option>
            <option value="completed_pickls_count-ASC">Pickls &#8593;</option>
            <option value="completed_pickls_count-DESC">Pickls &#8595;</option>
          </select>
        </div>
      </div>

      <div class="filter-panel">
        <div class="filter-panel-header" @click="toggleDemographicFilters">
          <span class="filter-panel-title">Demographics Filters</span>
          <span class="filter-toggle" v-html="showDemographicFilters ? '−' : '+'"></span>
        </div>
        <div class="filter-panel-body" v-show="showDemographicFilters">
          <select v-model="gender">
            <option value="">Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Non-Binary">Non-Binary</option>
          </select>
          <select v-model="age">
            <option value="">Age</option>
            <option value="13-18">13-18</option>
            <option value="18-25">18-25</option>
            <option value="26-35">26-35</option>
            <option value="36-45">36-45</option>
            <option value="46-55">46-55</option>
            <option value="56-65">56-65</option>
            <option value="66-75">66-75</option>
            <option value="76-85">76-85</option>
            <option value="86-95">86-95</option>
          </select>
          <select v-model="children">
            <option value="">Children</option>
            <option value="1 child">1 child</option>
            <option value="2 children">2 Children</option>
            <option value="3 or more children">3 or more children</option>
            <option value="No children">No children</option>
          </select>
          <select v-model="pets">
            <option value="">Pets</option>
            <option value="Dog">Dog</option>
            <option value="Cat">Cat</option>
            <option value="Fish">Fish</option>
            <option value="Bird/Small Animal">Bird/Small Animal</option>
            <option value="Reptile/Other">Reptile/Other</option>
            <option value="I don't have a pet">I don't have a pet</option>
          </select>
          <select v-model="ethnic_background">
            <option value="">Enthnic Background</option>
            <option v-for="eb in enthicBackgroundList" :value="eb" :key="eb">{{ eb }}</option>
          </select>
        </div>
      </div>

      <div class="filter-panel">
        <div class="filter-panel-header" @click="toggleActions">
          <span class="filter-panel-title">Actions</span>
          <span class="filter-toggle" v-html="showActions ? '−' : '+'"></span>
        </div>
        <div class="filter-panel-body" v-show="showActions">
          <button class="btn-positive btn-action" data-toggle="modal" data-target="#send-message-popup" v-if="userRole=='super-admin'">Send Message</button>
          <button class="btn-positive btn-action" data-toggle="modal" data-target="#send-notification-popup" v-if="userRole=='super-admin'">Send Notification</button>
          <button class="btn-positive btn-action" data-toggle="modal" data-target="#send-email-popup" v-if="userRole=='super-admin'">Send Email</button>
          <button class="btn-positive btn-action" data-toggle="modal" data-target="#send-chat-popup" v-if="userRole=='super-admin'">Send Chat</button>
          <button class="btn-positive btn-action" data-toggle="modal" data-target="#clear-blocked-users-popup" v-if="userRole=='super-admin'">Reset Message Blocked</button>
          <button class="btn-positive btn-action" data-toggle="modal" data-target="#clear-notification-blocked-users-popup" v-if="userRole=='super-admin'">Reset Notification Blocked</button>
          <button class="btn-positive btn-action" data-toggle="modal" data-target="#clear-email-blocked-users-popup" v-if="userRole=='super-admin'">Reset Email Blocked</button>
          <button class="btn-positive btn-action" data-toggle="modal" data-target="#send-email-for-new-feature" v-if="userRole=='super-admin'">Email New Feature/Bug Fix</button>
        </div>
      </div>
    </div>

    <SendMessagePopup popupId="send-message-popup" :checkedUsersList="checkedUsersArr" :excludeResponders="false" :picklId="null" @messageSent="messageSent" :selectAllPicklrs="selectAllPicklrs" :picklrFilters="picklrFilters" />
    <SendCustomNotificationPopup popupId="send-notification-popup" :checkedUsersList="checkedUsersArr" :excludeResponders="false" :picklId="null" @notificationSent="messageSent" :selectAllPicklrs="selectAllPicklrs" :picklrFilters="picklrFilters" />
    <SendEmailPopup popupId="send-email-popup" :checkedUsersList="checkedUsersArr" :excludeResponders="false" :picklId="null" @emailSent="messageSent" :selectAllPicklrs="selectAllPicklrs" :picklrFilters="picklrFilters" />
    <SendChatPopup popupId="send-chat-popup" :checkedUsersList="checkedUsersArr" :excludeResponders="false" :picklId="null" @chatSent="messageSent" :selectAllPicklrs="selectAllPicklrs" :picklrFilters="picklrFilters" />
    <ClearBlockedUsersPopup popupId="clear-blocked-users-popup" />
    <ClearNotificationBlockedUsersPopup popupId="clear-notification-blocked-users-popup" />
    <ClearEmailBlockedUsersPopup popupId="clear-email-blocked-users-popup" />
    <SendEmailForNewFeature popupId="send-email-for-new-feature" />

    <div class="toolbar" v-if="userRole=='super-admin'">
      <div class="toolbar-left">
        <input type="checkbox" :checked="selectAllPicklrs" @change="checkAllPicklrs($event)">
        <label>Select All Users</label>
      </div>
      <div class="toolbar-right">
        <span class="total-badge">Total: {{ totalPicklrs }}</span>
      </div>
    </div>

    <div class="row pickl-grid" v-if="picklrs.length > 0">
      <div class="col-xs-12 col-sm-6 col-md-4" v-for="picklr in picklrs" :key="picklr.id">
        <PicklrItem
          :picklr="picklr"
          :selectedPicklrs="checkedUsersArr"
          @updateCheckedUsers="checkedUsersList"
          :selectAllPicklrs="selectAllPicklrs"
        />
      </div>
    </div>

    <div class="empty-state" v-if="picklrs.length === 0 && !loadingPicklrs">No Users Found</div>
    <div class="loading-state" v-if="loadingPicklrs">Loading Users...</div>
    <div class="text-center" v-if="hasMorePicklrs && !loadingPicklrs" @click="getPicklrs" style="margin-top: 12px;">
      <button class="btn-positive">Load more</button>
    </div>
  </div>
</template>

<script>

import PicklrItem from '@/components/SAdmin/PicklrItem.vue'
import SendMessagePopup from '@/components/SAdmin/SendMessagePopup.vue'
import ClearBlockedUsersPopup from '@/components/SAdmin/ClearBlockedUsersPopup.vue'
import ClearNotificationBlockedUsersPopup from '@/components/SAdmin/ClearNotificationBlockedUsersPopup.vue'
import ClearEmailBlockedUsersPopup from '@/components/SAdmin/ClearEmailBlockedUsersPopup.vue'
import SendEmailForNewFeature from '@/components/SAdmin/SendEmailForNewFeature.vue'

import SendCustomNotificationPopup from '@/components/SAdmin/SendCustomNotificationPopup.vue'
import SendEmailPopup from '@/components/SAdmin/SendEmailPopup.vue'
import SendChatPopup from '@/components/SAdmin/SendChatPopup.vue'

export default {
  name: 'Picklr',
  data () {
    return {
      enthicBackgroundList: ['Multiracial/Mixed', 'Hispanic/LATAM', 'African American/Black', 'White', 'Asian or Pacific Islander', 'Middle Eastern', 'Native American/Other'],
      showPersonalDetailsFilter: true,
      gender: '',
      age: '',
      isEmailValid: '',
      children: '',
      ethnic_background: '',
      pets: '',
      cosmetics: '',
      showDemographicFilters: false,
      showActions: false,
      loadingPicklrs: true,
      hasMorePicklrs: false,
      city: '',
      zipCode: '',
      stateName: '',
      status: this.$route.query['status'] || 'ACTIVE',
      rowsLimitPerRequest: 100,
      rowsOffset: 0,
      picklrs: [],
      sort: this.$route.query['sortBy'] || 'created_at-DESC',
      name: '',
      email: '',
      mobileNumber: '',
      checkedUsersArr: [],
      userRole: 'super-admin',
      states: [],
      selectAllPicklrs: false,
      lat: this.$route.query['lat'] || '',
      lng: this.$route.query['lng'] || '',
      picklrFilters: {},
      countries: [],
      countryId: '',
      totalPicklrs: 0
    }
  },
  components: {
    PicklrItem,
    SendMessagePopup,
    ClearBlockedUsersPopup,
    SendCustomNotificationPopup,
    ClearNotificationBlockedUsersPopup,
    ClearEmailBlockedUsersPopup,
    SendEmailForNewFeature,
    SendEmailPopup,
    SendChatPopup
  },

  created () {
    this.$store.dispatch('getAppSettingsKeyValuePair')
  },
  mounted () {
    let userData = this.$store.state.userData
    this.userRole = userData.role
    this.getPicklrs()
    this.getCountries()
  },
  methods: {
    togglePersonalFilters () {
      this.showPersonalDetailsFilter = !this.showPersonalDetailsFilter
      console.log('here we are')
    },
    toggleDemographicFilters () {
      this.showDemographicFilters = !this.showDemographicFilters
    },
    toggleActions () {
      this.showActions = !this.showActions
    },
    getCountries () {
      this.$http.get('countries?service_enabled=true').then((response) => {
        this.countries = response.body.data
      })
    },
    checkAllPicklrs (e) {
      if (e.target.checked) {
        this.selectAllPicklrs = true
      } else {
        this.selectAllPicklrs = false
      }
    },

    getStatesByCountry () {
      this.picklrs = []
      this.rowsOffset = 0
      this.getPicklrs()
      if (this.countryId !== '') {
        this.$http.get('states?country_id=' + this.countryId).then((response) => {
          this.states = response.body.data
        })
      } else {
        this.states = []
      }
    },

    messageSent () {
      Object.assign(this.$data, (this.$options.data).apply(this))
      this.reFilter()
      this.checkedUsersArr = []
      this.getCountries()
    },

    checkedUsersList (selectedUsers, status) {
      const found = this.checkedUsersArr.indexOf(selectedUsers)
      if (status === 'added') {
        this.checkedUsersArr.push(selectedUsers)
      } else {
        this.checkedUsersArr.splice(found, 1)
      }
    },
    getPicklrs () {
      this.loadingPicklrs = true
      let q = {
        name: this.name,
        email: this.email,
        status: this.status,
        city: this.city,
        countryId: this.countryId,
        stateName: this.stateName,
        zipCode: this.zipCode,
        mobile_number: this.mobileNumber,
        limit: this.rowsLimitPerRequest,
        offset: this.rowsOffset,
        sort: this.sort,
        lat: this.lat,
        lng: this.lng,
        gender: this.gender,
        age: this.age,
        pets: this.pets,
        children: this.children,
        ethnic_background: this.ethnic_background,
        is_email_valid: this.isEmailValid
      }
      this.picklrFilters = q
      this.$http
        .get('picklrs', { params: q })
        .then(
          function (response) {
            if (this.rowsLimitPerRequest === q.limit && this.rowsOffset === q.offset) {
              this.rowsOffset += this.rowsLimitPerRequest
              this.picklrs.push(...response.body.data)
              this.selectAllPicklrs = false
              this.totalPicklrs = response.body.count
              if (this.picklrs.length === response.body.count) {
                this.hasMorePicklrs = false
              } else {
                this.hasMorePicklrs = true
              }
              this.loadingPicklrs = false
            }
          }
        )
    },
    reFilter () {
      this.picklrs = []
      this.rowsOffset = 0
      this.getPicklrs()
      this.$router.push({ query: { sortBy: this.sort, status: this.status, lat: this.lat, lng: this.lng } })
    }
  },
  watch: {
    sort () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    name () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    email () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    city () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    zipCode () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    status () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    stateName () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    mobileNumber () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    age () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    gender () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    ethnic_background () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    pets () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    children () {
      this.$common.delay(() => {
        this.reFilter()
      }, 500)()
    },
    isEmailValid () {
      this.reFilter()
    }
  }
}
</script>

<style scoped>
.picklrs-page {
  padding: 0;
}

.filter-panels {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.filter-panel {
  flex: 1;
  min-width: 200px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}

.filter-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8faf7;
  cursor: pointer;
  border-bottom: 1px solid #e2e8f0;
  transition: background 0.15s ease;
}

.filter-panel-header:hover {
  background: #f0f4ee;
}

.filter-panel-title {
  font-size: 12px;
  font-weight: 600;
  color: #2d3748;
  letter-spacing: 0.2px;
}

.filter-toggle {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #6B8F5E;
  color: white;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  flex-shrink: 0;
}

.filter-panel-body {
  padding: 10px 12px;
}

.filter-panel-body select,
.filter-panel-body .btn-select {
  margin-bottom: 5px;
  margin-right: 4px;
}

.btn-action {
  margin: 3px 4px 3px 0;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 10px;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.toolbar-left label {
  font-size: 12px;
  font-weight: 500;
  color: #2d3748;
  margin: 0;
}

.toolbar-left input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin: 0;
}

.toolbar-right .total-badge {
  font-size: 12px;
  font-weight: 600;
  color: #4a5568;
  background: #f7f8fa;
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
}

.picklr-list {
  background: transparent;
}

.empty-state,
.loading-state {
  text-align: center;
  padding: 30px 0;
  font-size: 14px;
  font-weight: 500;
  color: #718096;
}

@media only screen and (max-width: 767px) {
  .filter-panels {
    flex-direction: column;
  }
}
</style>
